module.exports = __webpack_public_path__ + "img/horizontal_4_7_8003.87f7a176.png";